export default "__VITE_ASSET__9f166673__"